import { useLayoutEffect, useRef, useState } from "react";
import GUI, { IGUIProps } from "../GUI";

export type TMeasureProps = IGUIProps & {
    id?:string
    children:React.ReactNode
    onMeasure?:(overflow:boolean) => void
}
export default function Measure(props:TMeasureProps){
    const [overflow,setOverlow] = useState<boolean>(false)
    const container = useRef<HTMLDivElement|null>(null)
    const content = useRef<HTMLDivElement|null>(null)

    useLayoutEffect(() => {
        if (!container.current || !content.current) return
        const observer = new ResizeObserver(() => {
            if (!container.current || !content.current) return
            const overflow = content.current.clientWidth>container.current.clientWidth
            props.onMeasure?.(overflow)
            setOverlow(overflow)
        })
        observer.observe(container.current)
        return () => { observer.disconnect() }
    }, [props.children])

    const id = props.id ? {id:props.id} : {}
    return <div className={GUI.joinClass("measure", overflow ? "overflow" : "")} ref={container} {...id} style={{overflow:"hidden"}}>
        <div ref={content} className={GUI.joinClass("measure-content", props.className)} style={{width:"max-content"}}>{props.children}</div>
    </div>
}